import * as React from "react"
import { Outlet, useLocation } from "react-router-dom"

import { Sidebar } from "@/components/layout/sidebar"
import { Topbar } from "@/components/layout/topbar"

const COLLAPSE_KEY = "antifraud.sidebar.collapsed"

/**
 * Оболочка консоли: тёмная колонна меню слева, шапка сверху, рабочее поле
 * справа. Свёрнутость меню держим в `localStorage` — аналитик разворачивает её
 * один раз под свой монитор, и терять этот выбор при каждом переходе незачем.
 * Это чисто оформительское состояние, никакого отношения к данным правил оно не
 * имеет: состояние тумблеров живёт в Postgres и читается оттуда.
 *
 * На узком экране (`< md`) колонна в поток не встаёт — иначе её 216px съедали бы
 * почти весь вьюпорт телефона и выдавливали шапку с рабочим полем за правый
 * край (документ уезжал в горизонтальный скролл). Там меню становится
 * выдвижной шторкой поверх контента: открывается «гамбургером» в шапке, гасится
 * тапом по затемнению или переходом по пункту.
 */
export function Shell() {
  const [collapsed, setCollapsed] = React.useState(
    () => window.localStorage.getItem(COLLAPSE_KEY) === "1",
  )
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const { pathname } = useLocation()

  const toggle = React.useCallback(() => {
    setCollapsed((previous) => {
      const next = !previous
      window.localStorage.setItem(COLLAPSE_KEY, next ? "1" : "0")
      return next
    })
  }, [])

  const closeMobile = React.useCallback(() => setMobileOpen(false), [])

  // Смена маршрута закрывает шторку: тап по пункту меню не должен оставлять её
  // висеть поверх только что открытой страницы.
  React.useEffect(() => {
    setMobileOpen(false)
  }, [pathname])

  return (
    <div className="flex h-full min-h-0 bg-canvas">
      <Sidebar
        collapsed={collapsed}
        onToggle={toggle}
        mobileOpen={mobileOpen}
        onCloseMobile={closeMobile}
      />
      {mobileOpen && (
        <button
          type="button"
          aria-label="Close menu"
          onClick={closeMobile}
          className="fixed inset-0 z-30 bg-ink/50 md:hidden"
        />
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenMenu={() => setMobileOpen(true)} />
        <main className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
